import { MODEL_VERSION, SITE } from '@/app/constants';
import type { SupportedLanguage } from '@/app/types';
import { type CompactExample, expandExamples } from './utils';

export const ZH_GUIDE_URL = 'https://shengshu.feishu.cn/docx/Dtv8dbnUKo5glfxDoLXcEwzSnyd';
export const EN_GUIDE_URL = 'https://shengshu.feishu.cn/docx/MtKHd8OhNokOtaxzxQHcdUDPnKh';

const BASE_URL =
  SITE === 'global'
    ? 'https://image01.cf.vidu.studio/vidu/media-asset'
    : 'https://image01-aliyun.vidu.zone/vidu/media-asset';

const CHAR2V_EXAMPLES_COMPACT = [
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/c2v-01-1-3601199e.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/c2v-01-2-08b1b82e.webp`,
        },
        {
          name: 'image3',
          url: `${BASE_URL}/c2v-01-3-300bae49.webp`,
        },
      ],
      text: '[@image1] is riding [@image2] running fast in [@image3] far view from above',
      thumbnail: `${BASE_URL}/1-262babcb.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/c2v-01-1-3601199e.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/c2v-01-2-08b1b82e.webp`,
        },
        {
          name: '图3',
          url: `${BASE_URL}/c2v-01-3-300bae49.webp`,
        },
      ],
      text: '[@image1]骑着[@image2]的黑马，在[@image3]中飞快奔跑，从上空往下看视角',
      thumbnail: `${BASE_URL}/1-262babcb.webp`,
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/c2v-02-1-08798503.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/c2v-02-2-78589a7d.webp`,
        },
      ],
      text: '[@image1] is running in [@image2]',
      thumbnail: `${BASE_URL}/2-2903e8d8.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/c2v-02-1-08798503.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/c2v-02-2-78589a7d.webp`,
        },
      ],
      text: '[@image1]在[@image2]奔跑',
      thumbnail: `${BASE_URL}/2-2903e8d8.webp`,
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/c2v-03-1-0a00f07e.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/c2v-03-2-d60a2675.webp`,
        },
        {
          name: 'image3',
          url: `${BASE_URL}/c2v-03-3-1de01957.webp`,
        },
      ],
      text: '[@image1] wears [@image3] skating shoes, skating happily, elegantly in [@image2], spins',
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/c2v-03-1-0a00f07e.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/c2v-03-2-d60a2675.webp`,
        },
        {
          name: '图3',
          url: `${BASE_URL}/c2v-03-3-1de01957.webp`,
        },
      ],
      text: '[@image1]穿着[@image3]滑冰鞋在[@image2]优雅地滑冰，转圈',
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/${SITE === 'global' ? 'c2v' : 'char2v'}-04-1-en-22f4303a.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/c2v-04-2-c73878cf.webp`,
        },
        {
          name: 'image3',
          url: `${BASE_URL}/c2v-04-3-en-cf9773e2.webp`,
        },
      ],
      text: 'The person in [@image1] is wearing [@image2] and walking in [@image3]',
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/c2v-04-1-55abf966.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/c2v-04-2-c73878cf.webp`,
        },
        {
          name: '图3',
          url: `${BASE_URL}/c2v-04-3-c1992e1a.webp`,
        },
      ],
      text: '[@image1]的人物戴着[@image2]站在[@image3]场景中',
      thumbnail: `${BASE_URL}/c2v-04-2-c73878cf.webp`,
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/c2v-05-1${SITE === 'global' ? '' : '-small'}-d5b52be7.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/c2v-05-${SITE === 'global' ? '2' : '1'}-32be8a39.webp`,
        },
        {
          name: 'image3',
          url: `${BASE_URL}/c2v-05-3-ff5df5e7.webp`,
        },
      ],
      text: 'The person in [@image1] is wearing [@image2] and sitting in [@image3]',
      thumbnail: `${BASE_URL}/c2v-05-${SITE === 'global' ? '2' : '1'}-32be8a39.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/c2v-05-1${SITE === 'global' ? '' : '-small'}-d5b52be7.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/c2v-05-${SITE === 'global' ? '2' : '1'}-32be8a39.webp`,
        },
        {
          name: '图3',
          url: `${BASE_URL}/c2v-05-3-ff5df5e7.webp`,
        },
      ],
      text: '[@image1]的人物戴着[@image2]耳机，坐在[@image3]',
      thumbnail: `${BASE_URL}/c2v-05-${SITE === 'global' ? '2' : '1'}-32be8a39.webp`,
    },
  },
];

const CHAR2V_Q3A_EXAMPLES_COMPACT = CHAR2V_EXAMPLES_COMPACT.slice(0, 3);

const CHAR2V_PRO_EXAMPLES_COMPACT: CompactExample[] = [
  // 1. 删除@视频1中的男性
  {
    en: {
      images: [],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/1-81c32f2d.mp4`,
          coverUrl: `${BASE_URL}/1-cover-e3cab3fc.webp`,
          duration: 5,
        },
      ],
      text: 'Remove the male character from [@video1]',
      thumbnail: `${BASE_URL}/1-cover-e3cab3fc.webp`,
    },
    zh: {
      images: [],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/1-81c32f2d.mp4`,
          coverUrl: `${BASE_URL}/1-cover-e3cab3fc.webp`,
          duration: 5,
        },
      ],
      text: '删除 [@video1] 中的男性',
      thumbnail: `${BASE_URL}/1-cover-e3cab3fc.webp`,
    },
  },
  // 2. 改变背景氛围和房屋灯光
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/2-19a66d48.webp`,
        },
      ],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/2-272478a3.mp4`,
          coverUrl: `${BASE_URL}/2-cover-2b8dc0d0.webp`,
          duration: 7,
        },
      ],
      text: 'Keep the character, snowy environment, and houses in [@video1] unchanged. Adjust the overall background color tone to the dusk blue-hour style of [@image1], and turn on the lights in the houses',
      thumbnail: `${BASE_URL}/2-cover-2b8dc0d0.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/2-19a66d48.webp`,
        },
      ],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/2-272478a3.mp4`,
          coverUrl: `${BASE_URL}/2-cover-2b8dc0d0.webp`,
          duration: 7,
        },
      ],
      text: '[@video1] 中人物、雪地和房屋不变，背景色调改成 [@image1] 的黄昏蓝调时刻，房屋亮起灯光',
      thumbnail: `${BASE_URL}/2-cover-2b8dc0d0.webp`,
    },
  },
  // 3. 添加大黄鸭
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/3-98c21016.webp`,
        },
      ],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/3-bdf3f69d.mp4`,
          coverUrl: `${BASE_URL}/3-cover-37af9721.webp`,
          duration: 5,
        },
      ],
      text: 'Add the big yellow duck from [@image1] to a suitable position in [@video1]',
      thumbnail: `${BASE_URL}/3-cover-37af9721.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/3-98c21016.webp`,
        },
      ],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/3-bdf3f69d.mp4`,
          coverUrl: `${BASE_URL}/3-cover-37af9721.webp`,
          duration: 5,
        },
      ],
      text: '将 [@image1] 中的大黄鸭添加到 [@video1] 合适的位置上',
      thumbnail: `${BASE_URL}/3-cover-37af9721.webp`,
    },
  },
  // 4. 将猫放到人物腿上并抚摸
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/4-7c3fc675.webp`,
        },
      ],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/4-a57f0d1f.mp4`,
          coverUrl: `${BASE_URL}/4-cover-8fe28baa.webp`,
          duration: 5,
        },
      ],
      text: "Place the cat from [@image1] on the person's legs in [@video1], with the person raising a hand to gently pet the kitten",
      thumbnail: `${BASE_URL}/4-cover-8fe28baa.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/4-7c3fc675.webp`,
        },
      ],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/4-a57f0d1f.mp4`,
          coverUrl: `${BASE_URL}/4-cover-8fe28baa.webp`,
          duration: 5,
        },
      ],
      text: '将 [@image1] 中的猫放到 [@video1] 中人物的腿上，人物抬手轻轻抚摸小猫',
      thumbnail: `${BASE_URL}/4-cover-8fe28baa.webp`,
    },
  },
  // 5. 替换背景为乡间小路
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/5-b2efa09a.webp`,
        },
      ],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/5-6c16bd5e.mp4`,
          coverUrl: `${BASE_URL}/5-cover-6c907840.webp`,
          duration: 5,
        },
      ],
      text: 'Replace the background of [@video1] with the country road from [@image1]',
      thumbnail: `${BASE_URL}/5-cover-6c907840.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/5-b2efa09a.webp`,
        },
      ],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/5-6c16bd5e.mp4`,
          coverUrl: `${BASE_URL}/5-cover-6c907840.webp`,
          duration: 5,
        },
      ],
      text: '把 [@video1] 中的背景替换成 [@image1] 的乡间小路',
      thumbnail: `${BASE_URL}/5-cover-6c907840.webp`,
    },
  },
  // 6. 替换为卡通熊
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/6-478f79bf.webp`,
        },
      ],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/6-06e81956.mp4`,
          coverUrl: `${BASE_URL}/6-cover-81afad1e.webp`,
          duration: 5,
        },
      ],
      text: 'Replace the boy playing the piano in [@video1] with the cartoon bear from [@image1]',
      thumbnail: `${BASE_URL}/6-cover-81afad1e.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/6-478f79bf.webp`,
        },
      ],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/6-06e81956.mp4`,
          coverUrl: `${BASE_URL}/6-cover-81afad1e.webp`,
          duration: 5,
        },
      ],
      text: '将 [@video1] 中弹钢琴的男孩替换为 [@image1] 中的卡通熊',
      thumbnail: `${BASE_URL}/6-cover-81afad1e.webp`,
    },
  },
  // 7. 改成16:9横屏
  {
    en: {
      images: [],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/7-8ce9ee12.mp4`,
          coverUrl: `${BASE_URL}/7-cover-70f5fb83.webp`,
          duration: 5,
        },
      ],
      text: 'Change the aspect ratio of [@video1] to 16:9 landscape video',
      thumbnail: `${BASE_URL}/7-cover-70f5fb83.webp`,
      settings: {
        aspect_ratio: '16:9',
      },
    },
    zh: {
      images: [],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/7-8ce9ee12.mp4`,
          coverUrl: `${BASE_URL}/7-cover-70f5fb83.webp`,
          duration: 5,
        },
      ],
      text: '将 [@video1] 比例改成 16:9 横屏视频',
      thumbnail: `${BASE_URL}/7-cover-70f5fb83.webp`,
      settings: {
        aspect_ratio: '16:9',
      },
    },
  },
  // 8. 改变咖啡杯材质
  {
    en: {
      images: [],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/8-56fdc2ea.mp4`,
          coverUrl: `${BASE_URL}/8-cover-2d970663.webp`,
          duration: 5,
        },
      ],
      text: 'Change the material of the two coffee cups in [@video1] to a knitted texture',
      thumbnail: `${BASE_URL}/8-cover-2d970663.webp`,
    },
    zh: {
      images: [],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/8-56fdc2ea.mp4`,
          coverUrl: `${BASE_URL}/8-cover-2d970663.webp`,
          duration: 5,
        },
      ],
      text: '把 [@video1] 中两杯咖啡杯的材质改为针织材质',
      thumbnail: `${BASE_URL}/8-cover-2d970663.webp`,
    },
  },
  // 9. 添加金钱雨效果
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/9-b1f126ae.webp`,
        },
      ],
      videos: [
        {
          name: 'video1',
          url: `${BASE_URL}/9-833d00cf.mp4`,
          coverUrl: `${BASE_URL}/9-cover-b9cbd270.webp`,
          duration: 5,
        },
      ],
      text: 'Apply the money rain effect from [@video1] to [@image1]',
      thumbnail: `${BASE_URL}/9-cover-b9cbd270.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/9-b1f126ae.webp`,
        },
      ],
      videos: [
        {
          name: '视频1',
          url: `${BASE_URL}/9-833d00cf.mp4`,
          coverUrl: `${BASE_URL}/9-cover-b9cbd270.webp`,
          duration: 5,
        },
      ],
      text: '让 [@image1] 也拥有 [@video1] 中的金钱雨效果',
      thumbnail: `${BASE_URL}/9-cover-b9cbd270.webp`,
    },
  },
];

const IMG2V_EXAMPLES_COMPACT = [
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/i2v-01-1-en-dcb21d0a.webp`,
        },
      ],
      text: 'Soldiers detect a target! Bullet fires in slow-mo—capture the moment',
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/i2v-01-1-v2-da251914.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/i2v-01-2-4a0ece43.webp`,
        },
      ],
      text: '镜头最开始是一只熟睡的小猫，然后推进到森林，出现了一只咆哮的狮子',
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/i2v-02-1-ebe3cf46.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/i2v-02-2-e9275db3.webp`,
        },
      ],
      text: 'transit seamlessly from image1 to image2',
      thumbnail: `${BASE_URL}/i2v-02-2-e9275db3.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/i2v-02-1-ebe3cf46.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/i2v-02-2-e9275db3.webp`,
        },
      ],
      text: '变为图二，无缝转场',
      thumbnail: `${BASE_URL}/i2v-02-2-e9275db3.webp`,
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/i2v-04-1-en-03-fe6a358e.webp`,
        },
      ],
      text: 'Push the camera and the girl smiles.',
    },

    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/i2v-03-1-2fdc95c9.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/i2v-03-2-1de44aa4.webp`,
        },
      ],
      text: '镜头推进，人物从水中慢慢地浮现出水面',
      thumbnail: `${BASE_URL}/i2v-03-2-1de44aa4.webp`,
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/i2v-03-1-2fdc95c9.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/i2v-03-2-1de44aa4.webp`,
        },
      ],
      text: 'camera zoom in, figures slowly rise up from the water',
      thumbnail: `${BASE_URL}/i2v-03-2-1de44aa4.webp`,
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/i2v-04-1-dd62ef4b.webp`,
        },
      ],
      text: '推镜头，男孩睁开眼',
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/i2v-05-1-756f23f0.webp`,
        },
      ],
      text: "In a cinematic shot, the wind tosses the girl's hair, and she turns her head toward the camera",
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/i2v-05-1-756f23f0.webp`,
        },
      ],
      text: '电影感，风迎面吹来，人物扭头看向镜头',
    },
  },
];

const IMG2V_Q3_EXAMPLES_COMPACT = [
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/1-67bf07f8.webp`,
        },
      ],
      text: 'The girl looks forward naturally and says, "Welcome to the Vidu Q3 model."',
      settings: {
        duration: 4,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/1-67bf07f8.webp`,
        },
      ],
      text: '女孩自然地看向前方，说：“欢迎使用 Vidu Q3”',
      settings: {
        duration: 4,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/2-a6b92d88.webp`,
        },
      ],
      text: `A kitten and a puppy host a radio program.
The puppy says: "The owner said he doesn’t believe in love anymore—he only wants to make money."
The kitten replies: "That means he has neither love nor money."
After that, the kitten and the puppy burst into loud laughter together.`,
      settings: {
        duration: 8,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/2-a6b92d88.webp`,
        },
      ],
      text: `小猫和小狗做电台 
小狗说：主人说他不相信爱情了，只想搞钱 
小猫说：那说明他既没爱情也没钱 
说完后小猫小狗一起大声哈哈笑`,
      settings: {
        duration: 8,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/3-8d393c9f.webp`,
        },
      ],
      text: "Starting from this World War II fighter cockpit perspective, generate a tense aerial combat follow-up video. The camera remains locked to the pilot's first-person viewpoint throughout.",
      settings: {
        duration: 10,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/3-8d393c9f.webp`,
        },
      ],
      text: '以这张二战战斗机驾驶舱视角为开篇，生成一段紧张空战后续视频，镜头全程锁定第一人称飞行员视角。',
      settings: {
        duration: 10,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/4-d1ed84f5.webp`,
        },
      ],
      text: `A kitten hosts a news broadcast.
In a professional news-anchor voice, it reports:
"Breaking news: a dairy cow-pattern cat robber has appeared in the eastern district, robbing the Cat Food Bank."`,
      settings: {
        duration: 5,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/4-d1ed84f5.webp`,
        },
      ],
      text: '小猫主持新闻联播\n用播音腔播报：本台最新消息，城东区出现奶牛猫劫匪抢劫猫粮银行',
      settings: {
        duration: 5,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/q3-img2video-sample-5-836e6528.webp`,
        },
      ],
      text: 'The woman looks directly at the man, voice calm but hurt, and says:\nI told you the life I wanted… but you always ignore me.\nA brief silence follows.\nThe man avoids eye contact at first, then looks back at her,\nhis voice low, defensive yet tired, and replies:\nI didn’t ignore you. I just thought what I was giving was enough.\nMinimal movement, subtle breathing and micro facial expressions,\nno dramatic gestures, realistic pacing.',
      settings: {
        duration: 10,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/q3-img2video-sample-5-836e6528.webp`,
        },
      ],
      text: '女人直视着男人，语气平静，却带着受伤的情绪，说道：\n“我早就告诉过你，我想要怎样的生活……可你总是选择忽视。”\n短暂的沉默随之而来。\n男人最初避开她的目光，随后又看向她，声音低沉，带着防御与疲惫，回应道：\n“我没有忽视你。我只是以为，我已经付出的那些已经足够了。”\n动作极少，仅有细微的呼吸起伏与面部微表情变化，没有夸张的肢体动作，节奏真实克制。',
      settings: {
        duration: 10,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/q3-img2video-sample-6-b7953e49.webp`,
        },
      ],
      text: 'Amid intense game music and explosive sound effects, a player is deeply immersed in a fierce gaming session. As the camera pushes in and circles around him, the sound of his frantic button-mashing and his rapid breathing grows louder. The camera settles into a front close-up as he stares at the screen and shouts, “Come on… Come on! Damn it!”',
      settings: {
        duration: 5,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/q3-img2video-sample-6-b7953e49.webp`,
        },
      ],
      text: '激昂的游戏音乐和爆炸声中，一名玩家正激烈地游戏。随着镜头推近和环绕，他疯狂敲击手柄的声音和急促的呼吸声愈发清晰。镜头环绕至正面特写，他紧盯着屏幕，嘶吼道"Come on… Come on! Damn it!"。',
      settings: {
        duration: 5,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/q3-img2video-sample-7-cb9b0e7c.webp`,
        },
      ],
      text: 'The camera pushes in as the man says, “I don’t need to—I’ve got a lifetime to find out.”',
      settings: {
        duration: 10,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/q3-img2video-sample-7-cb9b0e7c.webp`,
        },
      ],
      text: '镜头缓缓推进，男人开口说道：“我不着急——我有一辈子的时间去弄明白。”',
      settings: {
        duration: 10,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/q3-img2video-sample-8-56cdd487.webp`,
        },
      ],
      text: 'The character says in Japanese: “Welcome to creating videos with the Vidu Q3 model.”',
      settings: {
        duration: 3,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/q3-img2video-sample-8-56cdd487.webp`,
        },
      ],
      text: '人物用日语说：欢迎使用Vidu Q3模型创作视频',
      settings: {
        duration: 3,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/q3-img2video-sample-9-805949a1.webp`,
        },
      ],
      text: 'Generate a video based on the input image, preserving the original content and structure without adding any new elements\nThis is a sequential narrative, progressing smoothly from the first panel to the last with a stable, consistent pacing\nPlay the panels in the order shown in the image, presenting each panel one by one without skipping or reordering\nOnly apply subtle camera movements such as gentle push-ins, pans, or fade transitions, without altering the composition or cropping the main subject\nMaintain a visual style consistent with the original image, realistic and natural, with no exaggerated effects\nEnsure clear visuals, restrained motion, and smooth transitions',
      settings: {
        duration: 10,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/q3-img2video-sample-9-805949a1.webp`,
        },
      ],
      text: '基于输入图片生成视频，保持原图内容与结构，不新增元素\n这是一个按顺序播放的故事画面，从第一格到最后一格依次展开，画面连贯，节奏稳定\n按照图片中顺序播放，每一格依次呈现，不跳过、不打乱顺序\n镜头只做轻微推进、平移或淡入淡出，不改变构图，不裁切画面主体\n整体风格保持与原图一致，真实自然，无夸张特效\n画面清晰，动作克制，过渡自然',
      settings: {
        duration: 10,
      },
    },
  },
  {
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/q3-img2video-sample-10-55aa37ee.webp`,
        },
      ],
      text: 'Generate a video based on the input four-panel image, preserving the original content and structure without adding any new elements\nThis is a panel-by-panel narrative, progressing sequentially from the first panel to the fourth with steady pacing\nPlay each panel in the order shown in the image, presenting them one at a time without skipping or reordering\nOnly apply subtle camera movements such as gentle push-ins, pans, or fade transitions, without altering the composition or cropping the main subject\nMaintain a visual style consistent with the original image, realistic and natural, with no exaggerated effects\nEnsure clear visuals, restrained motion, and smooth transitions',
      settings: {
        duration: 6,
      },
    },
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/q3-img2video-sample-10-55aa37ee.webp`,
        },
      ],
      text: '基于输入的四宫格图片生成视频，保持原图内容与结构，不新增元素\n这是一个按格子顺序播放的故事画面，从第一格到第四格依次展开，画面连贯，节奏稳定\n按照图片中顺序播放，每一格依次呈现，不跳过、不打乱顺序\n镜头只做轻微推进、平移或淡入淡出，不改变构图，不裁切画面主体\n整体风格保持与原图一致，真实自然，无夸张特效\n画面清晰，动作克制，过渡自然',
      settings: {
        duration: 6,
      },
    },
  },
];

const REFERENCE2IMAGE_EXAMPLES_COMPACT: CompactExample[] = [
  {
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/r2i-1-1-07b65da0.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/r2i-1-2-1147b489.webp`,
        },
      ],
      text: '[@image2]替换[@image1]的墨镜',
      thumbnail: `${BASE_URL}/r2i-thumb-1-4e3c8066.webp`,
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/r2i-1-1-07b65da0.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/r2i-1-2-1147b489.webp`,
        },
      ],
      text: 'Replace [@image1]’s sunglasses with [@image2]',
      thumbnail: `${BASE_URL}/r2i-thumb-1-4e3c8066.webp`,
    },
  },
  {
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/r2i-2-5-1d9eebdf.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/r2i-2-3-caed67e8.webp`,
        },
        {
          name: '图3',
          url: `${BASE_URL}/r2i-2-4-6b466b27.webp`,
        },
        {
          name: '图4',
          url: `${BASE_URL}/r2i-2-1-74be7505.webp`,
        },
        {
          name: '图5',
          url: `${BASE_URL}/r2i-2-2-3da2a714.webp`,
        },
      ],
      text: '短焦鱼眼 仰视大特写镜头，[@image1]头上带着[@image3]，身上披着[@image2]，手里拿着一根[@image5]放在口中，在正在下雨的[@image4]中，[@image1]的眼睛在镜头前',
      thumbnail: `${BASE_URL}/r2i-thumb-2-74be7505.webp`,
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/r2i-2-5-1d9eebdf.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/r2i-2-3-caed67e8.webp`,
        },
        {
          name: 'image3',
          url: `${BASE_URL}/r2i-2-4-6b466b27.webp`,
        },
        {
          name: 'image4',
          url: `${BASE_URL}/r2i-2-1-74be7505.webp`,
        },
        {
          name: 'image5',
          url: `${BASE_URL}/r2i-2-2-3da2a714.webp`,
        },
      ],
      text: 'Short-focus fisheye, low-angle extreme close-up: [@image1] wears [@image3] on the head, draped in [@image2], holding a [@image5] and placing it in the mouth, in the raining [@image4], with [@image1]’s eyes right in front of the lens',
      thumbnail: `${BASE_URL}/r2i-thumb-2-74be7505.webp`,
    },
  },
  {
    zh: {
      images: [
        {
          name: '图1',

          url: `${BASE_URL}/r2i-3-2-d9881411.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/r2i-3-1-629ebba1.webp`,
        },
      ],
      text: '[@image2]怀里抱着[@image1]，坐在地上，背景白色',
      thumbnail: `${BASE_URL}/r2i-thumb-3-629ebba1.webp`,
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/r2i-3-2-d9881411.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/r2i-3-1-629ebba1.webp`,
        },
      ],
      text: '[@image2] holding [@image1] in the arms, sitting on the ground, white background. ',
      thumbnail: `${BASE_URL}/r2i-thumb-3-629ebba1.webp`,
    },
  },
  {
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/r2i-4-2-1fb8a7b2.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/r2i-4-1-5f61bc3a.webp`,
        },
      ],
      text: '在一个下雨天的傍晚，一位留着长白发的帅气少女[@image2]身穿黑色西装，正冷静地站在窗户旁边，她手中握着一把大口径狙击枪[@image1]，通过瞄准镜俯瞰着下方的街道。整个画面是90年代动画电影的风格，充满了紧张的氛围。',
      thumbnail: `${BASE_URL}/r2i-thumb-4-5f61bc3a.webp`,
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/r2i-4-2-1fb8a7b2.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/r2i-4-1-5f61bc3a.webp`,
        },
      ],
      text: 'On a rainy evening, a handsome girl with long white hair [@image2], dressed in a black suit, stands calmly by the window, holding a large-caliber sniper rifle [@image1] and observing the street below through the scope. The entire scene is in the style of a 1990s animated film, filled with a tense atmosphere.',
      thumbnail: `${BASE_URL}/r2i-thumb-4-5f61bc3a.webp`,
    },
  },

  {
    zh: {
      images: [
        {
          name: '图1',

          url: `${BASE_URL}/r2i-5-2-1fdeb50e.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/r2i-5-1-b59cd308.webp`,
        },
      ],
      text: '[@image1]戴上[@image2]帽子，角度不变，风格不变，背景不变',
      thumbnail: `${BASE_URL}/r2i-thumb-5-fb1c3188.webp`,
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/r2i-5-2-1fdeb50e.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/r2i-5-1-b59cd308.webp`,
        },
      ],
      text: '[@image1] put on [@image2] hat, angle unchanged, style unchanged, background unchanged',
      thumbnail: `${BASE_URL}/r2i-thumb-5-fb1c3188.webp`,
    },
  },
  {
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/sample1-1-8985b0fb.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/sample1-2-c3e3f573.webp`,
        },
        {
          name: '图3',
          url: `${BASE_URL}/sample1-3-ea5fbd32.webp`,
        },
      ],
      text: '将[@image1]中的两个人物替换成[@image2]和[@image3]',
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/sample1-1-8985b0fb.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/sample1-2-c3e3f573.webp`,
        },
        {
          name: 'image3',
          url: `${BASE_URL}/sample1-3-ea5fbd32.webp`,
        },
      ],
      text: 'Replace the two characters in [@image1] with the characters from [@image2] and [@image3].',
    },
  },
  {
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/sample2-1-c881f56a.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/sample2-2-77b8b329.webp`,
        },
      ],
      text: '将[@image1]材质改为[@image2]',
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/sample2-1-c881f56a.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/sample2-2-77b8b329.webp`,
        },
      ],
      text: 'Change the material of [@image1] to match [@image2].',
    },
  },
  {
    zh: {
      images: [
        {
          name: '图1',
          url: `${BASE_URL}/sample3-1-ac43be6c.webp`,
        },
        {
          name: '图2',
          url: `${BASE_URL}/sample3-2-997441fb.webp`,
        },
      ],
      text: '把[@image1]中两人手里抱着的花换成[@image2]的小狗',
    },
    en: {
      images: [
        {
          name: 'image1',
          url: `${BASE_URL}/sample3-1-ac43be6c.webp`,
        },
        {
          name: 'image2',
          url: `${BASE_URL}/sample3-2-997441fb.webp`,
        },
      ],
      text: 'Replace the flowers held by the two people in [@image1] with the puppy from [@image2].',
    },
  },
];

export const getExamplesChar2V = (locale: SupportedLanguage, modelVersion?: string) => {
  if (modelVersion === MODEL_VERSION.Q2_PRO) {
    return expandExamples(CHAR2V_PRO_EXAMPLES_COMPACT, locale);
  }
  if (modelVersion === MODEL_VERSION.Q3_A) {
    return expandExamples(CHAR2V_Q3A_EXAMPLES_COMPACT, locale);
  }
  return expandExamples(CHAR2V_EXAMPLES_COMPACT, locale);
};

export const getExamplesImg2V = (locale: SupportedLanguage, modelVersion?: string) => {
  if (modelVersion === MODEL_VERSION.Q4) {
    // Q4 复用通用样例，排除明确推广 Q3 的口播样例。
    const examples = IMG2V_Q3_EXAMPLES_COMPACT.filter((example) => !example.en.text.includes('Vidu Q3'));
    return expandExamples(examples, locale);
  }
  if (modelVersion === MODEL_VERSION.Q3 || modelVersion === MODEL_VERSION.Q3_HH) {
    return expandExamples(IMG2V_Q3_EXAMPLES_COMPACT, locale);
  }
  return expandExamples(IMG2V_EXAMPLES_COMPACT, locale);
};

export const getExamplesRef2Image = (locale: SupportedLanguage) =>
  expandExamples(REFERENCE2IMAGE_EXAMPLES_COMPACT, locale);

export const REQUIRED_KEYS = ['style', 'motionLevel'];

export const CHAR2V_TUTORIALS = [
  {
    type: 'tutorial' as const,
    videoUrl: {
      en: `${BASE_URL}/tutorial-char2v-en-beb120f1.mp4`,
      zh: `${BASE_URL}/tutorial-char2v-zh-37c41ec0.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/tutorial-char2v-en-025ab398.webp`,
      zh: `${BASE_URL}/tutorial-char2v-zh-546fa8ed.webp`,
    },
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-01-en-ffb16cc6.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster1-21212be0.webp`,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-02-en-cfb0ebd9.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster2-5e503b55.webp`,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-03-en-2278a518.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster3-bdb78d84.webp`,
    },
    exampleIndex: 2,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-04-en-f63a6f2c.mp4`,
      zh: `${BASE_URL}/c2v-04-440bbc5f.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster4-7077f41f.webp`,
      zh: `${BASE_URL}/poster5-1e604d77.webp`,
    },
    exampleIndex: 3,
  },
];

export const CHAR2V_PRO_TUTORIALS = [
  CHAR2V_TUTORIALS[0],
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-1-192c9ee9.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-1-bf0c6ca5.webp`,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-2-788014db.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-2-67dd77e2.webp`,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-3-a77f2eef.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-3-657e0818.webp`,
    },
    exampleIndex: 4,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-4-3766439f.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-4-92d8bfbc.webp`,
    },
    exampleIndex: 5,
  },
];

export const IMG2V_TUTORIALS = [
  {
    type: 'tutorial' as const,
    videoUrl: {
      en: `${BASE_URL}/tutorial-i2v-en-02fd61c1.mp4`,
      zh: `${BASE_URL}/tutorial-i2v-zh-f7b80686.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/tutorial-i2v-en-a84591ed.webp`,
      zh: `${BASE_URL}/tutorial-i2v-zh-1d23a1e9.webp`,
    },
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-01-en-d636fc0d.mp4`,
      zh: `${BASE_URL}/i2v-01-43ec8d94.mp4`,
    },
    posterUrl: {
      en: IMG2V_EXAMPLES_COMPACT[0].en.images[0].url,
      zh: IMG2V_EXAMPLES_COMPACT[0].zh.images[0].url,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-02-4514772f.mp4`,
    },
    posterUrl: {
      en: IMG2V_EXAMPLES_COMPACT[1].en.images[0].url,
      zh: IMG2V_EXAMPLES_COMPACT[1].zh.images[0].url,
    },
    thumbnailUrl: {
      en: IMG2V_EXAMPLES_COMPACT[1].en.images[1].url,
      zh: IMG2V_EXAMPLES_COMPACT[1].zh.images[1].url,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-03-en-f7e22c71.mp4`,
      zh: `${BASE_URL}/i2v-03-0c3f870b.mp4`,
    },
    posterUrl: {
      en: IMG2V_EXAMPLES_COMPACT[2].en.images[0].url,
      zh: IMG2V_EXAMPLES_COMPACT[2].zh.images[0].url,
    },
    thumbnailUrl: {
      zh: IMG2V_EXAMPLES_COMPACT[2].zh.images[1].url,
    },
    exampleIndex: 2,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-03-0c3f870b.mp4`,
      zh: `${BASE_URL}/i2v-04-a6320d49.mp4`,
    },
    posterUrl: {
      en: IMG2V_EXAMPLES_COMPACT[3].en.images[0].url,
      zh: IMG2V_EXAMPLES_COMPACT[3].zh.images[0].url,
    },
    thumbnailUrl: {
      en: IMG2V_EXAMPLES_COMPACT[3].en.images[1].url,
      zh: IMG2V_EXAMPLES_COMPACT[3].zh.images[0].url,
    },
    exampleIndex: 3,
  },
];

export const IMG2V_Q3_TUTORIALS = [
  IMG2V_TUTORIALS[0],
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-1-ecf49481.mp4`,
      zh: `${BASE_URL}/q3-1-zh-f22c4a05.mp4`,
    },
    posterUrl: {
      en: IMG2V_Q3_EXAMPLES_COMPACT[0].en.images[0].url,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-2-ed4dcdc3.mp4`,
      zh: `${BASE_URL}/q3-2-zh-74525126.mp4`,
    },
    posterUrl: {
      en: IMG2V_Q3_EXAMPLES_COMPACT[1].en.images[0].url,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-3-fa1bb759.mp4`,
      zh: `${BASE_URL}/q3-3-zh-fa1bb759.mp4`,
    },
    posterUrl: {
      en: IMG2V_Q3_EXAMPLES_COMPACT[2].en.images[0].url,
    },
    exampleIndex: 2,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-4-69da09ee.mp4`,
      zh: `${BASE_URL}/q3-4-zh-ba4571f1.mp4`,
    },
    posterUrl: {
      en: IMG2V_Q3_EXAMPLES_COMPACT[3].en.images[0].url,
    },
    exampleIndex: 3,
  },
];

export const getChar2VTutorials = (modelVersion?: string) => {
  if (modelVersion === MODEL_VERSION.Q2_PRO) {
    return CHAR2V_PRO_TUTORIALS;
  }
  return CHAR2V_TUTORIALS;
};

export const getImg2VTutorials = (modelVersion?: string) => {
  if (modelVersion === MODEL_VERSION.Q3) {
    return IMG2V_Q3_TUTORIALS;
  }
  return IMG2V_TUTORIALS;
};

export const BACKFILL_TIME_DELAY = 1000;
